import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { ThumbnailPlaceholder } from "./ThumbnailPlaceholder";
import addWatermarkToFile from "../helpers/addWaterMark";
      import { infoIconStyle, inputContainerStyle, formGroupStyle } from "./styles/stepperStyles";
const infoIconPath = "../../../assets/images/info-button.png"

export const ThumbnailManager = ({
  thumbnails,
  setStepperFormdata,
  fieldErrors,
  tooltipImage,
  tooltipAlt,
}) => {
  const [thumbnailUrls, setThumbnailUrls] = useState({});
  const isUploadDisabled = thumbnails?.length >= 4;

  const handleFileChange = async (event) => {
    const selectedFiles = Array.from(event.target.files);
    const maxFiles = 4;

    const currentFiles = thumbnails || [];
    const combinedFiles = [...currentFiles, ...selectedFiles].slice(
      0,
      maxFiles
    );

    const watermarkedFiles = await Promise.all(
      combinedFiles.map((file) => addWatermarkToFile(file))
    );

    setStepperFormdata((prevData) => ({
      ...prevData,
      thumbnails: watermarkedFiles,
    }));

    event.target.value = null;
  };

  const handleDeleteFile = (index) => {
    setStepperFormdata((prevData) => ({
      ...prevData,
      thumbnails: prevData.thumbnails.filter((_, i) => i !== index),
    }));
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(thumbnails || []);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setStepperFormdata((prev) => ({
      ...prev,
      thumbnails: items,
    }));
  };

  // Cleanup object URLs when files are removed
  useEffect(() => {
    const newUrls = {};
    thumbnails?.forEach((file, index) => {
      if (!thumbnailUrls[index] && file) {
        if (file instanceof File) {
          newUrls[index] = URL.createObjectURL(file);
        } else if (typeof file === "object" && file.image) {
          newUrls[index] = file.image;
        } else if (typeof file === "string") {
          newUrls[index] = file;
        }
      }
    });

    // Cleanup old URLs
    Object.entries(thumbnailUrls).forEach(([index, url]) => {
      if (!thumbnails?.[index]) {
        URL.revokeObjectURL(url);
      }
    });

    if (Object.keys(newUrls).length > 0) {
      setThumbnailUrls((prev) => ({ ...prev, ...newUrls }));
    }

    return () => {
      Object.values(thumbnailUrls).forEach((url) => {
        if (url.startsWith("blob:")) {
          URL.revokeObjectURL(url);
        }
      });
    };
  }, [thumbnails]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexGrow: 1,
      }}
    >
      <div className="d-flex align-items-center" style={{ width: "100%", marginBottom: "12px" }}>
      <div style={formGroupStyle}>
      <div className="info-icon-container">
        <img src={infoIconPath} alt="Info" style={infoIconStyle} />
        {tooltipImage && (
          <div className="info-tooltip">
            <img src={tooltipImage} alt={tooltipAlt} />
          </div>
        )}
      </div>
    </div>
        <label
          style={{
            backgroundColor: isUploadDisabled ? "#E0E0E0" : "#DBD9D4",
            cursor: isUploadDisabled ? "not-allowed" : "pointer",
            border: "2px solid #DBD9D4",
            borderRadius: "0.8rem",
            width: "100%",
            height: "48px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "16px",
          }}
          htmlFor="thubmnal"
        >
          Upload additional thumbnails (drag to reorder)
        </label>
        <input
          hidden
          id="thubmnal"
          type="file"
          name="thumbnails"
          onChange={handleFileChange}
          disabled={isUploadDisabled}
          multiple
        />
      </div>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="thumbnails" direction="horizontal">
          {(provided) => (
            <div
              className="d-flex flex-wrap gap-3 mt-3 justify-content-center"
              style={{
                maxWidth: "450px",
                minHeight: "100px",
                touchAction: "none",
              }}
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {[0, 1, 2, 3].map((placeholder, index) => {
                const file = thumbnails?.[index];
                return (
                  <Draggable
                    key={index.toString()}
                    draggableId={index.toString()}
                    index={index}
                    isDragDisabled={!file}
                  >
                    {(provided, snapshot) => (
                      <ThumbnailPlaceholder
                        index={index}
                        file={file}
                        onDelete={handleDeleteFile}
                        provided={provided}
                        snapshot={snapshot}
                      />
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

